import React from 'react';
import { createPortal } from 'react-dom';
import { SubCategoriesResponse } from '@api/fetchers/prime/types';
import { PillsWrapper, Pill } from './PrimeHome.styles';

interface PrimeHomePillsProps {
  subCategories: SubCategoriesResponse;
  selectedSubCategory: string;
  onSelectSubCategory: (uid: string) => void;
  subHeaderEl: HTMLElement | null;
}

const PrimeHomePills: React.FC<PrimeHomePillsProps> = ({
  subCategories,
  selectedSubCategory,
  onSelectSubCategory,
  subHeaderEl
}) => {
  if (!subCategories?.length || !subHeaderEl) {
    return null;
  }

  return createPortal(
    <PillsWrapper>
      {subCategories.map((subCategory) => {
        const isSelected = selectedSubCategory === subCategory.uid;

        return (
          <Pill
            key={subCategory.uid}
            $selected={isSelected}
            onClick={() => onSelectSubCategory(subCategory.uid)}
          >
            {subCategory.name}
          </Pill>
        );
      })}
    </PillsWrapper>,
    subHeaderEl
  );
};

export default PrimeHomePills;
